import React, { Component } from 'react';
import '../../App.css';
import Dimensions from 'react-dimensions';
import ReactPlayer from 'react-player';
const sancoLogo = require('../../media/sancoIcon_trans.png');

var firebase = require('firebase/app');
require('firebase/database');

const videos = [
      {
        videoTitle: 'Baja Cantina Promo',
        clipUrl: 'https://youtu.be/7bDoDbkoqv4'
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'Bisbees 2017',
        clipUrl: 'https://youtu.be/qwlm-AZjsok'
      },
      {
        videoTitle: 'Maria Corona Promo',
        clipUrl: 'https://youtu.be/9Ekp2jqeMyw'
      },
      {
        videoTitle: 'Pelagic FX-90 Tactical Fishing Shorts',
        clipUrl: 'https://youtu.be/ztNFa5ydT0U'
      },
      {
        videoTitle: 'Pelagic Polarized - Can You See the Fish?',
        clipUrl: 'https://youtu.be/n_5T6zTHdjw'
      },
      {
        videoTitle: '2017 Bisbees Black & Blue Marlin Tournament',
        clipUrl: 'https://www.youtube.com/watch?v=WuHKEpdA154' 
      },
      {
        videoTitle: 'Baja Cantina Promo',
        clipUrl: 'https://youtu.be/7bDoDbkoqv4'
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Pelagic Aquapak | Waterproof Gear Protection',
        clipUrl: 'https://www.youtube.com/watch?v=ebhJBKcL5ng'
      },
      {
        videoTitle: 'Bisbees 2016',
        clipUrl: 'https://www.youtube.com/watch?v=VCsB-abHMXA'
      },
      {
        videoTitle: 'Maria Corona Promo',
        clipUrl: 'https://youtu.be/9Ekp2jqeMyw'
      },
      {
        videoTitle: 'Pelagic FX-90 Tactical Fishing Shorts',
        clipUrl: 'https://youtu.be/ztNFa5ydT0U'
      },
      {
        videoTitle: 'Pelagic Polarized - Can You See the Fish?',
        clipUrl: 'https://youtu.be/n_5T6zTHdjw'
      },
      {
        videoTitle: 'Bisbees Black & Blue 2015',
        clipUrl: 'https://www.youtube.com/watch?v=p8cyCAhtPjs'
      },
      {
        videoTitle: 'Baja Cantina Promo',
        clipUrl: 'https://youtu.be/7bDoDbkoqv4'
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Pelagic Aquapak | Waterproof Gear Protection',
        clipUrl: 'https://www.youtube.com/watch?v=ebhJBKcL5ng'
      },
      {
        videoTitle: '2014 Bisbees Black & Blue Marlin Tournament',
        clipUrl: 'https://www.youtube.com/watch?v=MwOKpBxBkVk'
      },
      {
        videoTitle: 'Maria Corona Promo',
        clipUrl: 'https://youtu.be/9Ekp2jqeMyw'
      },
      {
        videoTitle: 'Pelagic FX-90 Tactical Fishing Shorts',
        clipUrl: 'https://youtu.be/ztNFa5ydT0U'
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Inaugural PELAGIC ROCKSTAR! Tuna Tournament',
        clipUrl: 'https://www.youtube.com/watch?v=_B4_dO0lZt8'
      },
      {
        videoTitle: 'Baja Cantina Promo',
        clipUrl: 'https://youtu.be/7bDoDbkoqv4'
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Pelagic Aquapak | Waterproof Gear Protection',
        clipUrl: 'https://www.youtube.com/watch?v=ebhJBKcL5ng'
      },
      {
        videoTitle: '2018 Pelagic Triple Crown of Fishing - Cabo Summer Slam',
        clipUrl: 'https://www.youtube.com/watch?v=8TGlmHzdGeg&t=14s'
      },
      {
        videoTitle: 'Maria Corona Promo',
        clipUrl: 'https://youtu.be/9Ekp2jqeMyw'
      },
      {
        videoTitle: 'Pelagic FX-90 Tactical Fishing Shorts',
        clipUrl: 'https://youtu.be/ztNFa5ydT0U'
      },
      {
        videoTitle: 'Pelagic Polarized - Can You See the Fish?',
        clipUrl: 'https://youtu.be/n_5T6zTHdjw'
      },
      {
        videoTitle: 'Pelagic Triple Crown of Fishing - Cabo Summer Slam',
        clipUrl: 'https://www.youtube.com/watch?v=S3kt7VJVZS8'
      },
      {
        videoTitle: 'Baja Cantina Promo',
        clipUrl: 'https://youtu.be/7bDoDbkoqv4'
      },
      {
        videoTitle: 'Pelagic Gear | Deep Sea Hybrid Shorts | Activated by Water',
        clipUrl: 'https://youtu.be/EgyOOgnQuvM'
      },
      {
        videoTitle: 'The Pelagic Aquapak | Waterproof Gear Protection',
        clipUrl: 'https://www.youtube.com/watch?v=ebhJBKcL5ng'
      },
    ];


class BajaCantina extends Component {
  
  constructor() {
    super();
    this.state = {
      currentVideo: videos[0],
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);  
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener("keyup", this.keyHandling);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener("keyup", this.keyHandling);
  }
  
  keyHandling = (e) => {
    if(e.keyCode === 179) {
      this.setState({
        vidPlaying: !this.state.vidPlaying
      })
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  
  nextVideo(currentVideo) {
    const videolist = videos;
    var i = videolist.length - 1;
    var index = videolist.indexOf(currentVideo);
    if(index !== i) {
      var next = index + 1;
    } else {
      var next = 0;
    }
    this.setState({
      currentVideo: videolist[next]
    })
  }
  
  render() {
    return (
      <div
        className='wrapper'
        width= {this.state.width}
        height= {this.state.height} >
        <ReactPlayer 
          url={this.state.currentVideo.clipUrl}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {
            this.nextVideo(this.state.currentVideo)
          }}
          playing />
          {this.state.currentVideo.videoTitle ? 
          <div className='overlay'>
            <div className='sancoLogo'>
              <img src={sancoLogo} height={40} width={40} />
            </div>
            <div className='title'>
              <div>
                {this.state.currentVideo.videoTitle}
              </div>
            </div>
          </div> : null }
      </div>
    );
  }
}

export default BajaCantina;



// WEBPACK FOOTER //
// ./src/pages/restaurants/BajaCantina.js